import { render, staticRenderFns } from "./AdRevenue.vue?vue&type=template&id=f6b4ca68&"
import script from "./AdRevenue.vue?vue&type=script&lang=js&"
export * from "./AdRevenue.vue?vue&type=script&lang=js&"
import style0 from "./AdRevenue.vue?vue&type=style&index=0&id=f6b4ca68&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports